import React from 'react';
import { Toast } from './toast';
import { useToast } from './ToastContext';


export const ToastContainer: React.FC = () => {
  const { state, removeToast } = useToast();

  const getUniquePositions = () => {
    return Array.from(new Set(state.toasts.map(t => t.position || 'top-right')));
  };

  const getToastsByPosition = (position: string) => {
    return state.toasts.filter(t => (t.position || 'top-right') === position);
  };

  return (
    <>
      {getUniquePositions().map(position => (
        <div key={position} className={`toast-container ${position}`}>
          {getToastsByPosition(position).map((toast) => (
            <Toast key={toast.id} {...toast} onRemove={removeToast} />
          ))}
        </div>
      ))}
    </>
  );
};